import React from 'react';

import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css } from 'styled-components';
import { switchProp } from 'styled-tools';

import { EpicField, MarketData, UPDATE_TYPES } from 'services/caxyLightstream';

const TrendSpan = styled.span<{ $trend: string }>`
  position: relative;
  @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
    font-size: 0.8125rem;
  }
  ${switchProp('$trend', {
    neutral: css`
      color: ${(props) => props.theme.colors.secondaryBlack};
    `,
    negative: css`
      color: ${(props) => props.theme.colors.ttRed};
    `,
    positive: css`
      color: ${(props) => props.theme.colors.upBlue};
    `,
  })}
`;

const Icon = styled(FontAwesomeIcon)`
  margin-left: 0.5rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

export interface ForexTablePriceCellProps {
  market?: MarketData;
  epicField: EpicField;
}

export const ForexTablePriceCell: React.FC<ForexTablePriceCellProps> = ({ market, epicField }) => {
  if (!market) {
    return <TrendSpan $trend='neutral'>-</TrendSpan>;
  }

  const marketEpic = market[epicField];

  if (market.UPDATE_TYPE.value === UPDATE_TYPES.SNAPSHOT) {
    return <TrendSpan $trend='neutral'>{marketEpic.value}</TrendSpan>;
  }

  if (marketEpic.change !== -1) {
    return (
      <TrendSpan $trend='positive'>
        {marketEpic.value}
        <Icon data-testid='positive' icon={faArrowUp} />
      </TrendSpan>
    );
  }

  return (
    <TrendSpan $trend='negative'>
      {marketEpic.value}
      <Icon data-testid='negative' icon={faArrowDown} />
    </TrendSpan>
  );
};
